import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api } from "@/pages/Admin";

const inputCls = "w-full bg-[#08080c] border border-white/15 px-3 py-2.5 text-sm text-white placeholder:text-slate-600 focus:border-[#00f0ff]";

export const PlaylistsManager = () => {
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => { api.get("/playlists").then((r) => setPlaylists(r.data)); }, []);

  const setField = (i, k, v) => setPlaylists(playlists.map((p, idx) => (idx === i ? { ...p, [k]: v } : p)));

  const save = async (p) => {
    try {
      const { id, ...body } = p;
      await api.put(`/playlists/${id}`, body);
      toast.success(`"${p.name}" updated`);
    } catch { toast.error("Could not update playlist"); }
  };

  return (
    <div className="space-y-6">
      <h2 className="font-display text-lg font-bold text-white uppercase">Official Playlists</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {playlists.map((p, i) => (
          <div key={p.id} className="bg-[#0c0c12] border border-white/10 p-6 space-y-3">
            <input data-testid={`admin-playlist-${i}-name`} value={p.name} onChange={(e) => setField(i, "name", e.target.value)} className={`${inputCls} font-display font-bold uppercase`} />
            <textarea data-testid={`admin-playlist-${i}-description`} rows={2} value={p.description} onChange={(e) => setField(i, "description", e.target.value)} className={inputCls} />
            {[["spotify_url", "Spotify URL"], ["apple_url", "Apple Music URL"], ["youtube_url", "YouTube Music URL"]].map(([k, label]) => (
              <div key={k}>
                <label className="block font-mono-tech text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-1">{label}</label>
                <input data-testid={`admin-playlist-${i}-${k}`} value={p[k]} onChange={(e) => setField(i, k, e.target.value)} className={inputCls} />
              </div>
            ))}
            <button data-testid={`admin-playlist-${i}-save`} onClick={() => save(p)} className="w-full flex items-center justify-center gap-2 px-5 py-2.5 bg-[#00f0ff] text-black font-mono-tech text-[11px] tracking-[0.2em] uppercase font-bold hover:bg-white transition-colors">
              <Save size={12} /> Save
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
